<template>
	<v-main>
		<AppBar title="휴대전화 변경" />
		<v-layout fill-height column>

			<v-container flex-fill fluid class="pb-0">
<!--				phone : {{phone}}-->
<!--				originPhone: {{originPhone}}-->
<!--				valid: {{valid}}-->
				<v-form class="form-item" v-model="valid">

					<label class="label">휴대전화</label>
					<div class="input-group mb-3">
						<v-text-field solo flat filled
									v-model.trim="phone"
									:rules="mobile_rule"
									required
									maxlength="11"
									oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
									@keydown.space.prevent
									placeholder="01012345678" />
						<v-btn :ripple="false"
								depressed
								color="primary"
								class="btn-input"
								width="115px"
								@click="doSendAuthCode"
								:disabled="!valid">인증번호 발송</v-btn>
					</div>

					<div class="input-group">
						<v-text-field solo flat filled
									v-model="authCode"
									required
									placeholder="인증번호를 입력" >
							<template #append>
								<Timer ref="timer" />
							</template>
						</v-text-field>
						<v-btn :ripple="false"
								depressed
								color="primary"
								class="btn-input"
								width="115px"
								:disabled="doSendChk=== -1"
								ref="authChkBtn"
								@click="checkAuthCode">확인</v-btn>
					</div>
					<div class="px-3 mt-n2">
						<span class="lightBlue--text fs-12" v-if="verify===true">인증 되었습니다.</span>
						<span class="error--text fs-12" v-else-if="verify===false">인증번호를 확인해주세요.</span>
					</div>
				</v-form>
			</v-container>

			<v-footer app fixed color="white" class="content-footer">
				<div class="footer-btns">
					<BlackBtn x-large str="변경하기" ref="btn" :disabled="doOk===-1"  @click="doChange" />
				</div>
			</v-footer>
		</v-layout>
	</v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn"
import Timer from "@/components/util/Timer.vue"
import store from "@/store";
export default {
	data: () => ({
		valid: false,
		name: '',
		phone: '',
		authCode:'',
		doSendChk : -1,
		doOk:-1,
		verify:null,
	}),
	components: {
		BlackBtn,
		Timer
	},
	watch : {
	},
	computed: {
    originPhone() {
      return store.getters.member.mobileNo
    },
		mobile_rule() {
			return [
				v => !!v || '휴대폰번호를 입력해주세요.'
				, v => !(v && v.length < 11) || '-(하이픈) 제외, 숫자만 입력해주세요.'
				, v => /^\d+$/.test(v) || '숫자만 입력 가능합니다.'
        , v => !(v === this.originPhone) || '이미 사용중인 휴대전화입니다.'
			]
		}
	},
	created() {
	},
	methods : {
		async checkAuthCode() {
			let query = {
				phone:this.phone,
				authCode:this.authCode,
				authType:'phone'
			};
			await store.dispatch('checkAuthCode', this.$_payload("param", query))
				.then(res => {
					if(res.success) {

						this.doSendChk = -1;
						this.$refs.timer.timerStop(this.$refs.timer.Timer);
						this.verify = true;
						//this.$refs.btn.disabled=false;
						this.doOk = 1;


					} else {
						//경고성 메시지 출력
						this.verify = false;
					}

				})
				.catch(error => {
					console.error(error)
				})
				.finally(()=>{})

		},
		/* 인증번호 발행 */
		async doSendAuthCode() {

			if(this.phone==="" || this.phone.length <= 0) {
				this.$alert("핸드폰번호를 입력하지 않았습니다.");
				return false;
			}

			await store.dispatch('generateSetAuthCode', this.$_payload(null,{phone:this.phone, authType:'phone'}))
				.then(res => {
					if(res.success) {
						this.$refs.timer.timerStart();
						this.doSendChk  = 1;
					}
				})
				.catch(error => {
					console.error(error)
				})
				.finally(()=>{})
		},
		async doChange () {
			let updateSetData = {
				mobileNo : this.phone
				,userKey:store.getters.userKey
			};

			await store.dispatch('setMemberInfoInner', this.$_payload('inData',updateSetData))
				.then(res => {
					if (res.success) {
            store.commit('setMemberInfo', {mobileNo : this.phone})
						this.$root.$children[0].$refs.toast.toastOpen('top','변경이 완료되었습니다.');
						this.prevPage()
					}
				}).catch(error => {
					console.error(error);
				}).finally(() => {
				})
		}
	}
}
</script>
<style lang="scss" scoped>
	.lightBlue--text {
		color:blue;
	}
//.pos-relative {
//	flex: 1 1 auto;
//}
//
//.v-input::v-deep {
//	.v-text-field__details {
//		padding-left: 0;
//	}
//}

.time {
	//position: absolute;
	//right: 8px;
	//top: 14px;
	color: var(--v-error-base);
	font-size: 14px;
}
</style>
